import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { compose, withProps } from 'recompose';
import { withRouter } from 'react-router-dom';
import {
  getCompleteDeals,
  getCompanyMatchCount,
  getCompleteDealsCount
} from '../../../store/selectors/deals';
import {
  getRatings,
  getAverageRatings,
  getRatingsCount
} from '../../../store/selectors/ratings';
import {
  getActiveCampaigns,
  getCampaigns
} from '../../../store/selectors/campaigns';
import { getProducts } from '../../../store/selectors/products';
import { withFirestore } from 'react-redux-firebase';

import {
  text__primary,
  text__primary_dark,
  white,
  deepPurple,
  grey,
  grey_dark,
  text__secondary
} from '../../../style';

const styles = theme => ({
  root: {
    width: '100%',
    padding: '30px',
    marginBottom: '30px'
  },
  layout: {
    width: '100%',
    background: '#f5f6fa',
    paddingTop: theme.spacing.unit * 7,
    paddingBottom: theme.spacing.unit * 10,
    paddingLeft: theme.spacing.unit * 4,
    paddingRight: theme.spacing.unit * 4,
    [theme.breakpoints.up('md')]: {
      width: 'calc(100% - 215px)',
      boxSizing: 'border-box'
    }
  },
  profilePicture: {
    maxWidth: '150px',
    background: white,
    minWidth: 120,
    minHeight: 120,
    '& > img': {
      width: '100%'
    }
  },
  profileStatsContainer: {
    textAlign: 'center',
    padding: '10px 30px',
    backgroundColor: 'white',
    borderRadius: 5,
    display: 'flex'
  },
  interestItem: {
    background: 'white',
    minHeight: '100%',
    width: 220,
    borderRadius: '15px',
    padding: '30px 10px',
    '& > *': {
      height: '100%'
    }
  },
  carouselItem: {
    objectFit: 'cover',
    background: 'white',
    position: 'relative',
    overflow: 'hidden',
    maxWidth: '250px',
    height: '250px'
  },
  productCarouselItem: {
    objectFit: 'cover',
    background: 'white',
    position: 'relative',
    overflow: 'hidden',
    width: '250px',
    height: '250px'
  },
  carouselContainer: {
    marginLeft: '50px'
  },
  carouselTop: {
    height: '200px'
  },
  carouselBottom: {
    position: 'absolute',
    height: '50px',
    width: '100%',
    zIndex: '100',
    background: 'black',
    opacity: '.65',
    color: 'white',
    bottom: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer'
  },
  carouselBottomImage: {
    maxWidth: '250px',
    maxHeight: '250px'
  },
  completedDealContainer: {
    background: 'white',
    height: '75px',
    width: '100%',
    marginBottom: '4px'
  },
  camapignLink: {
    '&:hover': {
      textDecoration: 'underline'
    },
    pointer: 'cursor'
  },
  subTitle: {
    marginBottom: 20
  },
  youtubeIcon: {
    color: white
  },
  icon: {
    width: '25px',
    height: '25px'
  },
  headerCell: {
    fontWeight: 'bold'
  },
  levelIconButton: {
    background: '#fcf5cb',
    '&:hover': {
      background: '#f3e594'
    }
  },
  levelIcon: {
    color: '#eed002'
  },
  industryIconButton: {
    background: '#d5dfe9',
    '&:hover': {
      background: '#b1cce6'
    }
  },
  industryIcon: {
    color: '#245c8b'
  },
  rating: {
    marginTop: '-4px',
    marginRight: 10
  },
  interest: {
    marginRight: '13px',
    borderRadius: '10px',
    background: 'white',
    padding: '7px'
  },
  interestContainer: {
    marginLeft: '9px',
    marginTop: '15px'
  },
  circleImage: {
    objectFit: 'cover',
    borderRadius: '50%',
    width: '200px',
    height: '200px'
  }
});

const mapStateToProps = state => {
  return {
    profile: state.firebase.profile,
    completedDeals: getCompleteDeals(state),
    completedDealsCount: getCompleteDealsCount(state),
    matchCount: getCompanyMatchCount(state),
    rating: getAverageRatings(state),
    ratings: getRatings(state),
    ratingsCount: getRatingsCount(state),
    campaigns: getCampaigns(state),
    activeCampaigns: getActiveCampaigns(state),
    products: getProducts(state)
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    // saveCampaignHandler: campaignInfo =>
    //   dispatch(saveCampaign(campaignInfo, ownProps))
  };
};

export default compose(
  withFirestore,
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withProps(({ profile }) => ({
    profile
  })),
  withStyles(styles),
  // Add props.router (used in handlers)
  withRouter
);



// WEBPACK FOOTER //
// ./src/components/company/profile/CompanyProfile.enhancer.js